import { render, staticRenderFns } from "./WealthSource.vue?vue&type=template&id=8dad1ad2&scoped=true"
import script from "./WealthSource.vue?vue&type=script&lang=js"
export * from "./WealthSource.vue?vue&type=script&lang=js"
import style0 from "./WealthSource.vue?vue&type=style&index=0&id=8dad1ad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dad1ad2",
  null
  
)

export default component.exports